import React from "react";
import {
    Grid, makeStyles, Paper, Typography,
} from "@material-ui/core";
import LogoIcon from "../components/svg/LogoIcon";

const useStyles = makeStyles((theme) => ({
    centerHorizontal: {
        marginLeft: "auto",
        marginRight: "auto",
    },
    grid: {
        backgroundColor: theme.palette.primary.main,
        height: "100%",
    },
    text: {
        color: "#fff",
    },
    icon: {
        width: "70%",
        height: "auto",
        maxHeight: "60%",
    },
    paper: {
        backgroundColor: "unset",
    },
}));


export default function Splash(): JSX.Element {
    const classes = useStyles();
    return (
        <Grid container justify="center" direction="column" className={`${classes.grid} `}>
            <Paper elevation={0} className={`${classes.centerHorizontal} ${classes.paper}` }>
                <LogoIcon />
            </Paper>
            <Typography variant="h1" className={`${classes.centerHorizontal} ${classes.text} `}>
                QUIZZERO
            </Typography>
        </Grid>
    );
}
